import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import t from '@/store/types';

export const mapStateToProps = (state: unknown, props: unknown) => {
  return {};
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  openDrawer: (name: string, payload?: unknown) =>
    dispatch({ type: t.OPEN_DRAWER, name, payload }),
  closeDrawer: (name: string, payload?: unknown) =>
    dispatch({ type: t.CLOSE_DRAWER, name, payload }),
});

export default connect(null, mapDispatchToProps);
